export const LINK_ACCESS_SESSION_KEY = 'linkAcesso.sessao';
export const PENDING_LINK_KEY = 'linkAcesso.chavePendente';

export type LinkAccessToken = {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  link_id: string;
};

export type LinkAccessSession = {
  linkId: string;
  expiraEm: number;
};

const SESSION_STORAGE_KEYS = ['autenticacao.token', 'usuario', 'cliente', LINK_ACCESS_SESSION_KEY];

const isLinkAccessSession = (value: unknown): value is LinkAccessSession => {
  if (!value || typeof value !== 'object') return false;
  const session = value as Record<string, unknown>;
  return typeof session.linkId === 'string' && typeof session.expiraEm === 'number';
};

export const startLinkAccessSession = (token: LinkAccessToken) => {
  const session: LinkAccessSession = {
    linkId: token.link_id,
    expiraEm: Date.now() + token.expires_in * 1000,
  };
  localStorage.setItem(LINK_ACCESS_SESSION_KEY, JSON.stringify(session));
};

export const getLinkAccessSession = (): LinkAccessSession | null => {
  const stored = localStorage.getItem(LINK_ACCESS_SESSION_KEY);
  if (!stored) return null;

  try {
    const parsed: unknown = JSON.parse(stored);
    return isLinkAccessSession(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const clearLinkAccessSession = () => {
  localStorage.removeItem(LINK_ACCESS_SESSION_KEY);
};

export const endLinkAccessSession = () => {
  SESSION_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
};
